module.exports = __webpack_public_path__ + "img/airakuen.bd137d98.jpg";